import { render, staticRenderFns } from "./other-params.vue?vue&type=template&id=163fe490&scoped=true"
import script from "./other-params.vue?vue&type=script&lang=ts"
export * from "./other-params.vue?vue&type=script&lang=ts"
import style0 from "./other-params.vue?vue&type=style&index=0&id=163fe490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163fe490",
  null
  
)

export default component.exports